import { Slugs } from 'common/urls/Slugs';
import React from 'react';
import { useRouteMatch } from 'react-router';
import { useCelebrityEventUpsellSegmentData } from 'src/celebrity-event/hooks/useCelebrityEventUpsellSegmentData';
import { OrderShefFragment } from 'src/gqlReactTypings.generated.d';
import { DishFirstShefsCardRow } from 'src/pages/consumer/dish-first/explore/components/Segments/DishFirstShefsCardRow';
import { useDishFirstExploreUrl } from 'src/pages/consumer/explore/useExploreUrl';
import { useCurrentUser } from 'src/shared/hooks/useCurrentUserHook';
import { Routes } from 'src/shared/Routes';
import { getSluggedPath } from 'src/shared/utils/RouteUtilities';
import { useCachedZipCode } from 'src/user-preferences/useCachedZipCode';
import styled from 'styled-components';
import { ScreenWidth } from 'web-common/src/shared/Constants';

const CenteredRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const ShefCardRowWithMenuWidth = styled(DishFirstShefsCardRow)`
  width: calc(100% + 30px);

  margin-right: -15px;
  margin-left: -15px;

  @media (min-width: ${ScreenWidth.SMALL}) {
    width: 800px;
    margin-left: unset;
    margin-right: unset;
  }
`;

interface IProps {
  className?: string;
  shef: OrderShefFragment;
}

export const PopularShefsCarousel: React.FC<IProps> = ({ className, shef }) => {
  const match = useRouteMatch();
  const filters = useDishFirstExploreUrl({ match });

  const [currentUser] = useCurrentUser();
  const [cachedZipCode] = useCachedZipCode();
  const explorePageZip = cachedZipCode ?? currentUser?.lastSearchedZipCode;

  const { updateQueryParams } = filters;

  const explorePage = getSluggedPath(Routes.CONSUMER_EXPLORE, [{ slug: Slugs.ZIP_CODE, value: explorePageZip ?? '' }]);

  const [segment, segmentMetrics] = useCelebrityEventUpsellSegmentData({ shef, filters });

  // If something goes wrong, the carousel can just hide itself
  if (!segment?.content?.items?.length || !segmentMetrics) return null;

  return (
    <CenteredRow className={className}>
      <ShefCardRowWithMenuWidth
        segment={segment}
        segmentMetrics={segmentMetrics}
        updateQueryParams={updateQueryParams}
        seeAllUrl={explorePage}
        showScrollButtons={false} // HACK: Scroll buttons collide with cart - hide for now
      />
    </CenteredRow>
  );
};
